export const CARD_HORIZONTAL_MARGIN = 20;
export const CARD_HEIGHT = 142;
export const PARALLAX_ADJACENT_ITEM_SCALE = 0.92;

// Chosen to leave an ~scale(8) visual gap on the 375px phone design:
// gap ~= ((1 - 0.92) / 2 * 375) + CARD_HORIZONTAL_MARGIN * (1 + 0.92) - 46.
export const PARALLAX_PEEK_OFFSET = 46;
